<template>
  <div class="relative mx-auto h-screen">
    <div class="hidden sm:block">
      <div class="absolute inset-0 bg-black opacity-80"></div>
      <img :src="background_image" class="h-screen splashImage w-full" />
    </div>

    <!-- login form  -->
    <div class="absolute top-[100px] opacity-40 hidden">
      <div>
        <div>
          <div
            style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);"
            class="w-[520px] text-white text-center h-[64px] pt-[15px] text-[32px] "
          >
            BUYERS PORTAL
          </div>
          <div
            style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);"
            class="
                  mb-4
                  text-[#ED7D31]
                  left-0
                  w-[520px]
                  text-center
                  justify-center
                  items-center
                  pb-[0px]
                  text-[11px]
                  "
          >
            BY MOLDEX REALTY, INC.
          </div>
        </div>
      </div>
      <div class="w-[520px] px-[89px]">
        <div>
          <div class="text-center  bg-white">
            <!-- if login  -->
            <div class="pt-4">
              <div>
                <!-- here  -->
                <div class="px-[20px]">
                  <div class="my-2">
                    <input
                      class="bg-white border-solid border-2 rounded-md border-black b w-full px-4 py-2 outline-none"
                      type="email"
                      readonly
                      placeholder="Email"
                    />
                  </div>
                  <div class="my-2 flex">
                    <div
                      class="border-solid border-2 rounded-md border-black flex  items-center"
                    >
                      <input
                        class="bg-white w-full rounded-md  px-4 py-2 outline-none"
                        :type="pwVisible ? 'password' : 'text'"
                        readonly
                        placeholder="Password"
                      />
                    </div>
                  </div>
                </div>
                <div class="flex justify-center my-4">
                  <div class="text-center w-full">
                    <div>
                      <button
                        class="
                                focus:outline-none
                                w-[140px]
                                rounded-md
                                text-white
                                bg-[#ED7D31]
                                h-[35px]
                                fontBtn
                              "
                      >
                        <div class="text-lg items-center flex justify-center">
                          Log in
                        </div>
                      </button>
                    </div>

                    <button
                      class="
                              focus:outline-none
                              w-[140px]
                              rounded-md
                              text-white
                              mt-2
                              bg-[#ED7D31]
                              h-[35px]
                              fontBtn
                            "
                    >
                      <div
                        class="text-lg
                      font-noto-sans items-center flex justify-center"
                      >
                        Sign Up
                      </div>
                    </button>
                    <div class="text-white w-full font5 mb-4 mt-1">
                      <!-- <div class="text-black text-lg">
                        {{ subtitle2 }}
                      </div> -->
                      <div class="text-black text-md font-noto-sans">
                        Sign up here.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-full">
                <div class="flex h-[20px] items-center pb-4">
                  <div
                    class="
                            capitalize
                            font-noto-sans
                            text-black
                            w-1/2
                            text-sm
                            text-left
                            pl-[20px]
                          "
                  >
                    Request for Password
                  </div>
                  <div
                    class="
                            text-xs
                            capitalize
                            text-black
                            w-1/2
                            text-right
                            pr-[20px]
                            font-noto-sans
                          "
                  >
                    Privacy Policy
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="items-center flex justify-center">
            <span
              ><img :src="moldex_logo" alt="" class="mt-[50px] w-[120px]"
            /></span>
          </div>
        </div>
      </div>
    </div>

    <!-- reset pw form  -->
    <div
      class="px-6 bg-white py-4 w-full max-w-[450px] mx-auto my-4 sm:w-[450px] sm:absolute sm:left-1/2 sm:top-20 sm:-translate-x-1/2"
    >
      <div class="flex justify-end items-center">
        <v-btn text @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <div class="py-4">
        <div class="w-full text-xl font-bold mb-2 text-center text-black">
          CREATE PASSWORD
        </div>
        <div class="text-center flex justify-center px-10 text-sm">
          For security purposes, we require a new password for your account.
        </div>
        <div class="text-left my-2 text-xs">
          Your password must have:
          <ul class="list-disc">
            <li>Minimum of twelve (12) characters</li>
            <li>At least one capital letter (A-Z)</li>
            <li>At least one lowercase letter (a-z)</li>
            <li>At least one number (0-9)</li>
            <li>At least one special character (e.g. ! ? * @ # $ & ^)</li>
          </ul>
        </div>
        <v-progress-linear
          v-if="loading"
          indeterminate
          color="primary"
        ></v-progress-linear>
        <div class="pt-4 pb-1">
          <form @submit.prevent="newPwSubmitted">
            <div class="space-y-1">
              <div>
                <v-text-field
                  clearable
                  v-model="passwordValue"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  hint="At least 12 characters"
                  placeholder="Encode your new password here"
                  name="input-10-1"
                  counter
                  outlined
                  @click:append="show1 = !show1"
                ></v-text-field>
                <v-text-field
                  clearable
                  v-model="rePasswordValue"
                  :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show2 ? 'text' : 'password'"
                  hint="At least 12 characters"
                  placeholder="Re-type your new password here"
                  name="input-10-1"
                  counter
                  outlined
                  @click:append="show2 = !show2"
                ></v-text-field>
              </div>
            </div>

            <password-meter
              v-if="passwordValue"
              :password="passwordValue"
              @score="onScore"
            />
            <div class="flex justify-center">
              <button
                class="w-full mt-4 rounded-md bg-[#ED7D31] py-2 text-white"
                type="submit"
              >
                Save New Password
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="text-black" v-if="strength && passwordValue">
        {{ capitalize(strength) }}
      </div>
      <div class="text-black" v-if="score === 0">Use a better password</div>

      <v-snackbar top v-model="snackbar" :timeout="3000">
        {{ snackbarText }}
      </v-snackbar>
    </div>
    <v-dialog
      v-model="successDialogPw"
      persistent
      :overlay="false"
      max-width="300px"
      transition="dialog-transition"
    >
      <div class="bg-white p-2">
        <div class="font-noto-sans text-md py-4">
          <div class="font-bold font-noto-sans text-center my-4">SUCCESS!</div>
          <div class="px-10">
            Your password has been successfully updated! You can now use your
            new password to log in. If you encounter any issues, please contact
            support.
          </div>
        </div>
        <div class="p-4">
          <v-btn @click="close" class="w-full">OK</v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import PasswordMeter from "vue-simple-password-meter";
import EventBus from "@/EventBus";

export default {
  components: {
    PasswordMeter,
  },
  data() {
    return {
      pwVisible: false,
      successDialogPw: false,
      moldex_logo: require("@/assets/images/moldex_logo.png"),
      background_image: require("@/assets/images/bg_login.jpg"),
      show1: false,
      show2: false,
      rules: {
        required: (value) => !!value || "Required.",
        min: (v) => v.length >= 12 || "Min 12 characters",
      },

      rePasswordValue: "",
      hidePw: true,
      passwordValue: "",
      score: null,
      strength: "",
      snackbar: false,
      snackbarText: "",
      loading: false,
    };
  },
  mounted() {
    EventBus.$on("snackbar_rfp", () => {
      this.snackbar = true;
      this.snackbarText =
        "Please check your email about your password request.";
    });
  },
  methods: {
    close() {
      this.$router.replace({ name: "Login" });
    },
    onSnackBar(text) {
      this.snackbar = true;
      this.snackbarText = text;
    },
    capitalize(text) {
      return text ? text.toUpperCase() : "";
    },
    onScore({ score, strength }) {
      this.strength = strength;
      this.score = score;
    },

    onPasswordInput() {
      // Add this method inside the methods section
      // Trigger the meter update only if passwordValue is not empty
      if (!this.passwordValue) {
        this.strength = "";
        this.score = null;
      }
    },

    validatePassword(password) {
      const minLength = password.length >= 12;
      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasNumber = /[0-9]/.test(password);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

      return (
        minLength && hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar
      );
    },

    async newPwSubmitted() {
      this.hidePw = true;

      if (!this.validatePassword(this.passwordValue)) {
        this.onSnackBar("Password does not meet the security requirements.");
      } else if (this.passwordValue !== this.rePasswordValue) {
        this.onSnackBar("Passwords do not match.");
      } else {
        this.loading = true;
        try {
          const data = {
            token: this.$route.query.token,
            newPassword: this.passwordValue,
          };
          const response = await axios.post("/password/reset", data);

          if (response.data.status) {
            this.successDialogPw = true;
          } else {
            this.onSnackBar(response.data.message);
          }
        } catch (error) {
          this.onSnackBar(
            error.response?.data?.message ||
              "An error occurred during the password reset process."
          );
          setTimeout(() => this.$router.replace({ name: "Login" }), 2000);
        } finally {
          this.loading = false;
          this.snackbar = true;
        }
      }
    },
  },
};
</script>

<style scoped>
.po-password-strength-bar {
  border-radius: 2px;
  transition: all 0.2s linear;
  height: 10px;
  margin-top: 8px;
}

.po-password-strength-bar.risky {
  background-color: #f95e68;
}

.po-password-strength-bar.guessable {
  background-color: #fb964d;
}

.po-password-strength-bar.weak {
  background-color: #fdd244;
}

.po-password-strength-bar.safe {
  background-color: #b0dc53;
}

.po-password-strength-bar.secure {
  background-color: #35cc62;
}
</style>
